import { useContext } from 'react';
import { createContext } from 'react';
import { DrawerCloseButtonProps } from '../@types/DrawerCloseButtonProps';

export const DrawerCloseButtonContext = createContext<DrawerCloseButtonProps>({} as DrawerCloseButtonProps);

DrawerCloseButtonContext.displayName = 'DrawerCloseButton';

const DrawerCloseButtonProvider = (props: DrawerCloseButtonProps) => (
	<DrawerCloseButtonContext.Provider value={props}>{props.children}</DrawerCloseButtonContext.Provider>
);

export const useDrawerCloseButton = () => {
	const context = useContext(DrawerCloseButtonContext);

	return context;
};

export default DrawerCloseButtonProvider;
